import React, {useContext, useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {
    FixelLogo,
    FormContainer, Row, StyledForm,
    StyledFormWrapper, StyledInput, StyledLabel,
    StyledLeftForm,
    StyledSignIn, StyledStar
} from "../signIn/signin.style";
import Recommendation from "../commons/recommendation/recommendation.compoenent";
import {
    PoweredBy,
    PurchaseButton,
    StyledRightForm, Terms
} from "./checkout.style";
import plansList from "../plans/plansList";
import {StyledInputGroupRow} from "../signUp/signup.style";
import {CardElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {StyledCardPrice} from "../plans/plans.style";
import {useAuthState} from "react-firebase-hooks/auth";
import Firebase from "../../services/firebase";
import {formDataWithToken, wpUrl } from "../../services/globalService";
import FixelDataContext from "../../context/FixelDataContext";
import {ErrorContainer, StyledPurchaseDetails, StyledTitle, SuccessContainer} from "../style/global.style";



const Checkout = (props) => {
    const { planId } = useParams();
    const [plan,setPlan] = useState({})
    const stripe = useStripe();
    const elements = useElements();
    const [user] = useAuthState(Firebase.auth);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const history = useHistory();
    const { fullFixelData } = useContext(FixelDataContext);

    const planType = fullFixelData?.plan?.type?.toLowerCase();
    const isCurrentActivePlan = planType && planType.toLowerCase() === plan?.name?.replace(" ", "_").toLowerCase() && fullFixelData?.plan?.state?.toLowerCase() === "active";
    const isActivePlan = fullFixelData?.plan?.state?.toLowerCase() === "active";
    const currentPlan = fullFixelData?.plan?.stripe_sub_id;
    const [coupon,setCoupon] = useState(props?.location?.coupon);

    useEffect(()=> {
        if(!props?.location?.plan) {
            const [planObj] = plansList.filter((plan) => {
                return plan.arrayId === planId
            })
            setPlan(planObj);
        }else {
            setPlan(props.location.plan)
        }
    },[planId,props.location.plan])

    useEffect( () => {
        setCoupon(props.location.coupon);
    },[props.location.coupon])

    const submit = async (e) => {
        e.preventDefault();
        if(isCurrentActivePlan){
            setError('Cannot purchase existing plan');
        }
        const card = elements.getElement(CardElement);
        if (!stripe || !elements) {
            return;
        }
        const {token} = await stripe.createToken(card,{email: user.email, name: `${firstName} ${lastName}` || user.displayName  });
        const createdTs = (token.created * 1000);
        const name = `${firstName} ${lastName}`;

        const purchaseObj = {
            stripe: {
                planId: plan.planId,
                stripeBillingName:name,
                stripeEmail: user.email,
                stripeToken: token.id,
                coupon: coupon
            },
            billingInfo: {
                customerId: -1,
                created_date: createdTs,
                name: name,
                email: user.email,
                company: null,
                fourDigits: token.card.last4,
                coupon: coupon,
                cardExpiration: new Date(token.card.exp_year, token.card.exp_month).getTime(),
                planId: plan.planId,
                planName: plan.name,
                transactionId: token.id,
                type: plan.name.replace(' ', '_'),
                price: plan.price
            }
        }
        const transport = {
            action: (isActivePlan && planType !== 'trial') ? 'fxl_change_plan' : 'fxl_pay',
            data: JSON.stringify(purchaseObj),
            currentPlan: currentPlan
        }
        try {
            const res = await formDataWithToken(wpUrl, transport);
            if(!res?.data?.success){
                setError(res?.data?.data?.message || 'There was a problem completing the payment, please try again later');
            }else {
                //payment success
                setSuccess('Thank you for your purchase, redirecting to dashboard');
                setTimeout(function (){
                    // redirect to / and refresh data
                    history.go(0);
                },3000)
            }
        }catch (e){
            console.error('checkout.comonent.js - 72', e?.message || e);
            setError('There was a problem completing the payment, please try again later')
        }
    }

    const onchange = (e) => {
        switch (e.target.name){
            case 'firstName':
                setFirstName(e.target.value);
                break;
            case 'lastName':
                setLastName(e.target.value);
                break;
            default:
                return;
        }
    }

    const cardElementOptions = {
        style: {
            base: {
                background: "#F5F5F5",
                border: "1px solid #DBDBDB",
                boxSizing: "border-box",
                borderRadius: "2.03125px",
                padding: "4rem",
                width: "100%",
                marginBottom: ".8rem",
                color: "#000",
                fontFamily: "Poppins, sans-serif",
                fontSize: "16px"
            }
        }
    }

    return (
        <StyledSignIn>
            <FixelLogo/>
            <StyledFormWrapper>
                <StyledLeftForm>
                    <FormContainer>
                        {error && <ErrorContainer>{error}</ErrorContainer>}
                        {success && <SuccessContainer>{success}</SuccessContainer>}
                        <StyledTitle>Payment details</StyledTitle>
                        <StyledForm>
                            <StyledInputGroupRow>
                                <div>
                                    <StyledLabel htmlFor="firstName">
                                        First Name
                                        <StyledStar>*</StyledStar>
                                    </StyledLabel>
                                    <StyledInput onChange={(e)=> onchange(e)}
                                                 type="text"
                                                 name="firstName"
                                                 placeholder="First name"
                                                 id="firstName"
                                    />
                                </div>
                                <div>
                                    <StyledLabel htmlFor="lastName">
                                        Last Name
                                        <StyledStar>*</StyledStar>
                                    </StyledLabel>
                                    <StyledInput
                                        type="text"
                                        name="lastName"
                                        placeholder="Last Name"
                                        id="lastName"
                                    />
                                </div>
                            </StyledInputGroupRow>
                            <CardElement options={cardElementOptions} className="card-element"/>
                        </StyledForm>
                        <Row>
                            <PurchaseButton onClick={(e)=> submit(e)}>
                                Submit payment
                            </PurchaseButton>
                        </Row>
                        <PoweredBy href={"https://www.stripe.com"}>
                            Powered By Stripe
                        </PoweredBy>
                    </FormContainer>
                </StyledLeftForm>
                <StyledRightForm>
                    <StyledPurchaseDetails>
                        <h4>{plan.name}</h4>
                        <StyledCardPrice>
                            <span>{plan.price}$</span>
                            <p>/month</p>
                        </StyledCardPrice>
                        <Terms>
                            {plan.terms}
                        </Terms>
                    </StyledPurchaseDetails>
                </StyledRightForm>
            </StyledFormWrapper>
            <Recommendation theme={'full'}/>
        </StyledSignIn>
    )
}

export default React.memo(Checkout)